import { getLocalData, getUrlParam, setSessionData, getSessionData, isRepeat, hasUserDetail } from "utils/util";
// import { browserHistory } from 'react-router';  // 确保你安装并引入了 react-router
import axios from "../../utils/new_request";
import toFinishedIcon from "../../static/img/xkCoach/icon-toFinished.svg";
import toFinishedBlackIcon from "../../static/img/xkCoach/icon-toFinished-black.svg";
import getReportPic from "../../static/img/get-report.png";
// import Header from '../component/header';
import "./SelectSubjectResult.less";
import { frontPath, xbagUrl, xkCoachLimitSchoolCodes } from "constant/constant";
import React from "react";

const combinationList_3_1_2 = [
    {
        id: 1,
        title: "物理组",
        children: [
            { id: [25, 26, 27], name: "物化生" },
            { id: [25, 26, 30], name: "物化地" },
            { id: [25, 26, 31], name: "物化政" },
            { id: [25, 27, 30], name: "物生地" },
            { id: [25, 27, 31], name: "物生政" },
            { id: [25, 30, 31], name: "物地政" },
        ],
    },
    {
        id: 2,
        title: "历史组",
        children: [
            { id: [29, 26, 27], name: "历化生" },
            { id: [29, 26, 30], name: "历化地" },
            { id: [29, 26, 31], name: "历化政" },
            { id: [29, 27, 30], name: "历生地" },
            { id: [29, 27, 31], name: "历生政" },
            { id: [29, 30, 31], name: "历地政" },
        ],
    },
];
const combinationList3_3 = [
    { id: 25, name: "物理", shortName: "物" },
    { id: 26, name: "化学", shortName: "化" },
    { id: 27, name: "生物", shortName: "生" },
    { id: 29, name: "历史", shortName: "历" },
    { id: 30, name: "地理", shortName: "地" },
    { id: 31, name: "政治", shortName: "政" },
];
const combinationList7_3 = [
    { id: 25, name: "物理", shortName: "物" },
    { id: 26, name: "化学", shortName: "化" },
    { id: 27, name: "生物", shortName: "生" },
    { id: 28, name: "技术", shortName: "技" },
    { id: 29, name: "历史", shortName: "历" },
    { id: 30, name: "地理", shortName: "地" },
    { id: 31, name: "政治", shortName: "政" },
];

class SelectSubjectResult extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectProvinceId: props.location.state.selectProvinceId || "",
            selectYear: props.location.state.selectYear || "",
            selectedCombinationList: props.location.state.selectedCombinationList || [],
            selectedCombinationNameList: [],
            selectedMinScore: props.location.state.selectedMinScore || "",
            selectedMaxScore: props.location.state.selectedMaxScore || "",
            selectedScoreRange: props.location.state.selectedScoreRange || {},
            analysisData: props.location.state.analysisData || {}, // 获取传递过来的分析数据
            analysisData2: props.location.state.analysisData2 || {},
            scoreTypeList: props.location.state.scoreTypeList || [],
            provinceId: props.location.state.selectProvinceId || "",
            year: props.location.state.selectYear || "",
            xkMode: props.location.state.xkMode || 1,
            allProvinceList: props.location.state.allProvinceList || [],
            selectedRegions: props.location.state.selectedRegions || [],
            selectedScoreType: props.location.state.selectedScoreType || 0,
            scoreTypeName: {
                0: "不限",
                10: "文科",
                20: "理科",
                30: "物理组",
                40: "历史组",
                50: "综合类",
            },
            selectedTags: props.location.state.selectedTags || [],
            selectedSchoolList: props.location.state.selectedSchoolList || [],
            selectedMajorList: props.location.state.selectedMajorList || [],
            selectionMode: props.location.state.selectionMode || "condition",
            overlayVisible: false,
            isExpanded: false, // Add this line to handle the expansion state
            isLongPress: false,
        };
        this.longPressTimer = null;
        // console.log("analysisData2",this.state.analysisData2)
    }
    dealSubjects_3_3 = (subjects) => {
        let { xkMode } = this.state;
        let selectedCombinationNameList = [];
        subjects.forEach((i) => {
            let childName = [];
            i.forEach((id) => {
                let name =
                    (xkMode == 1 ? combinationList3_3 : combinationList7_3).filter((c) => c.id == id)[0] &&
                    (xkMode == 1 ? combinationList3_3 : combinationList7_3).filter((c) => c.id == id)[0].shortName;
                childName.push(name);
            });
            selectedCombinationNameList.push(childName.join(""));
        });
        this.setState({
            selectedCombinationNameList,
        });
    };
    dealSubjects_3_1_2 = (subjects) => {
        let selectedCombinationNameList = [];
        subjects.forEach((i) => {
            if (i[0] == 25) {
                let name = combinationList_3_1_2[0].children.filter((c) => JSON.stringify(c.id) == JSON.stringify(i))[0]
                    .name;
                selectedCombinationNameList.push(name);
                let item = {};
                item.id = i;
                item.name = name;
            } else if (i[0] == 29) {
                let name = combinationList_3_1_2[1].children.filter((c) => JSON.stringify(c.id) == JSON.stringify(i))[0]
                    .name;
                selectedCombinationNameList.push(name);
                let item = {};
                item.id = i;
                item.name = name;
            }
        });
        this.setState({
            selectedCombinationNameList,
        });
    };

    handleBack = () => {
        // this.props.history.goBack();
        // 回到selectSubject页面，但是不清空数据
        this.props.history.push({
            pathname: "/selectSubject",
            state: {
                selectProvinceId: this.state.selectProvinceId,
                selectYear: this.state.selectYear,
                selectedCombinationList: this.state.selectedCombinationList,
                selectedMinScore: this.state.selectedMinScore,
                selectedMaxScore: this.state.selectedMaxScore,
                selectedScoreRange: this.state.selectedScoreRange,
                analysisData: this.state.analysisData,
                year: this.state.selectYear,
                provinceId: this.state.selectProvinceId,
                scoreTypeList: this.state.scoreTypeList,
                selectionMode: this.state.selectionMode,
            },
        });
    };

    dealProvinces = (provinces) => {
        // console.log(provinces)
        axios.get("/xbag/area/province/gets").then((provinceList) => {
            if (provinceList.errMsg || provinceList.message) {
                this.setState({ errMsg: provinceList.errMsg || provinceList.message });
            } else {
                provinceList.unshift({ id: 0, name: "不限" });
                let selectedProvinceListName = [];
                if (provinces.provinceIds && provinces.provinceIds.length > 0) {
                    provinces.provinceIds.forEach((i) => {
                        let item = provinceList.filter((p) => p.id == i)[0];
                        item && selectedProvinceListName.push(item.name);
                    });
                } else {
                    selectedProvinceListName.push("不限");
                }
                this.setState({
                    selectedProvinceListName,
                    provinceList,
                });
            }
        });
        this.setState({
            selectedProvinceList:
                provinces.provinceIds && provinces.provinceIds.length > 0 ? provinces.provinceIds : [0],
        });
    };

    componentDidMount() {
        // 成功进入结果页，埋点
        // console.log("进入结果页")
        window.gtag("event", "访问结果页", {
            send_to: "G-FKF7E7QZ8V",
        });

        const storedQueryData = localStorage.getItem("queryData");
        // console.log('storedQueryData', storedQueryData);
        if (storedQueryData) {
            const queryData = JSON.parse(storedQueryData);
            this.setState({
                selectProvinceId: queryData.selectProvinceId,
                selectYear: queryData.selectYear,
                selectedCombinationList: queryData.selectedCombinationList,
                selectedMinScore: queryData.selectedMinScore,
                selectedMaxScore: queryData.selectedMaxScore,
                selectedScoreRange: queryData.selectedScoreRange,
                analysisData: queryData.analysisData,
                year: queryData.selectYear,
                provinceId: queryData.selectProvinceId,
                scoreTypeList: queryData.scoreTypeList,
                selectionMode: queryData.selectionMode,
            });
        }

        // console.log('this.state', this.state);
        let { xkMode, provinceId, year, selectedCombinationList } = this.state;
        // console.log('xkMode', xkMode)
        // console.log(this.provinceId, this.year)

        if (xkMode == 1 || xkMode == 3) {
            //3+3
            // console.log("进入3+3处理逻辑")
            this.dealSubjects_3_3(selectedCombinationList);
            let selectedGroupList = [];
            selectedCombinationList.forEach((i, index) => {
                let item = { index: index, id: i };
                selectedGroupList.push(item);
            });
            this.setState({ selectedGroupList });
        } else {
            //3+1+2
            // console.log("进入3+1+2处理逻辑")
            // console.log("subjects",selectedCombinationList)
            this.dealSubjects_3_1_2(selectedCombinationList);
        }
    }

    handleBack = () => {
        this.props.history.goBack();
        this.props.history.push({
            pathname: "/selectSubject",
        });
    };

    handleGetReport = () => {
        this.setState({ overlayVisible: true });
    };

    handleCloseOverlay = () => {
        this.setState({ overlayVisible: false });
    };

    toggleExpand = () => {
        this.setState((prevState) => ({ isExpanded: !prevState.isExpanded }));
    };

    dealTotalTable = (analysisData) => {
        if (Object.keys(analysisData).length == 0) {
            let { selectedCombinationNameList } = this.state;
            let result = [];
            let item1 = { id: 1, title: "对比维度", content: selectedCombinationNameList };
            let item2 = { id: 2, title: "整体可选比例", content: [] };
            let item3 = { id: 3, title: "院校专业选科要求", content: [], total: 0 };
            selectedCombinationNameList.forEach((i) => {
                item2.content.push(0);
                item3.content.push(0);
            });
            result.push(item1, item2, item3);
            return result;
        } else {
            let { selectedCombinationNameList } = this.state;
            let result = [];
            let item1 = { id: 1, title: "对比维度", content: selectedCombinationNameList };
            let item2 = { id: 2, title: "整体可选比例", content: [] };
            let item3 = { id: 3, title: "院校专业选科要求", content: [], total: analysisData.totalEntryCount };
            analysisData.entryCountList.forEach((i) => {
                item2.content.push(
                    `${analysisData.totalEntryCount > 0 ? Math.round((i / analysisData.totalEntryCount) * 100) : 0}%`
                );
                item3.content.push(`可选 ${i}`);
            });
            result.push(item1, item2, item3);
            return result;
        }
    };
    dealUniversityTable = (analysisData) => {
        if (Object.keys(analysisData).length == 0) return [];
        let { selectedCombinationNameList } = this.state;
        let result = [];
        let item1 = { id: 1, title: "对比维度", content: selectedCombinationNameList };
        let item2 = { id: 2, title: "院校专业选科要求", content: [], total: analysisData.totalEntryCount };
        analysisData.entryCountList.forEach((i) => {
            item2.content.push(`可选 ${i}`);
        });
        result.push(item1, item2);
        return result;
    };
    handleClickSelectedSchoolStatus = () => {
        let { selectedSchoolListStatus } = this.state;
        this.setState({ selectedSchoolListStatus: selectedSchoolListStatus === "expand" ? "packup" : "expand" });
    };

    componentDidUpdate(prevProps, prevState) {
    if (this.state.overlayVisible && !prevState.overlayVisible) {
        this.handleOverlayLoad();
    }
    }
    
    handleOverlayLoad = () => {
    // 处理overlay加载后的埋点上报
    console.log('成功渲染overlay');
    // 打开添加信息，埋点
        window.gtag('event', '打开添加信息', {
            send_to: "G-FKF7E7QZ8V",
        });
    };

    handleMouseDown = () => {
        this.longPressTimer = setTimeout(() => {
            this.setState({ isLongPress: true });
            this.handleLongPress();
        }, 800); // 长按时间设置为800ms
    };

    handleMouseUp = () => {
        if (this.longPressTimer) {
            clearTimeout(this.longPressTimer);
        }
        if (!this.state.isLongPress) {
            this.handleClick();
        }
        this.setState({ isLongPress: false });
    };

    handleLongPress = () => {
        // 处理长按事件，例如进行埋点
        console.log("Long press detected");
        window.gtag("event", "长按图片", {
            send_to: "G-FKF7E7QZ8V",
        });
    };

    handleClick = () => {
        // 处理点击事件
        console.log("Click detected");
    };

    handleCloseOverlay = () => {
        this.setState({ overlayVisible: false });
    };

    render() {
        let {
            selectedCombinationNameList,
            selectedCombinationList,
            provinceList,
            selectedProvinceList,
            selectedScoreType,
            currentStep,
            selectedSchoolListStatus,
            selectedSchoolList,
            selectedProvinceListName,
            selectedScoreRange,
            analysisData,
            analysisData2,
            provinceId,
            year,
            selectedCombinationConfirmList,
            selectedGroupList,
            selectedGroupConfirmList,
            errTips,
            xkMode,
            scoreTypeList,
            allProvinceList,
            selectedRegions,
            selectedMajorList,
            selectionMode,
            overlayVisible,
            isExpanded, // Add this line to handle the expansion state
        } = this.state;

        // let scoreTypeName = scoreTypeList.filter(i => i.id == selectedScoreType)[0] && scoreTypeList.filter(i => i.id == selectedScoreType)[0].name;
        let isXkCoachLimit =
            this.user_detail &&
            this.user_detail.student &&
            this.user_detail.student.school &&
            (xkCoachLimitSchoolCodes.includes(this.user_detail.student.school.code) ||
                [35059, 974762].includes(this.user_detail.student.userId));
        // console.log("selectedCombinationNameList",selectedCombinationNameList)
        const displayConditions = [
            {
                label: "高考年份及地区",
                value: `${year}年, ${allProvinceList.find((i) => i.id === provinceId).name || "不限"}`,
            },
            {
                label: "意向专业",
                value: selectedMajorList.length > 0 ? selectedMajorList.map((i) => i.name).join("，") : "不限",
            },
        ];

        if (selectionMode === "condition") {
            displayConditions.push(
                {
                    label: "院校地区",
                    value:
                        selectedRegions.length > 0
                            ? allProvinceList
                                  .filter((i) => selectedRegions.includes(i.id))
                                  .map((i) => i.name)
                                  .join("，")
                            : "不限",
                },
                {
                    label: "院校分数",
                    value:
                        selectedScoreType !== 0
                            ? selectedScoreType === 50
                                ? selectedScoreRange.minScore
                                    ? `分数${selectedScoreRange.minScore}-${selectedScoreRange.maxScore}`
                                    : "不限"
                                : `分数${selectedScoreRange.minScore}-${selectedScoreRange.maxScore}`
                            : "不限",
                },
                {
                    label: "院校标签",
                    value:
                        this.state.selectedTags.length > 0 ? this.state.selectedTags.map((i) => i).join("，") : "不限",
                }
            );
        } else if (selectionMode === "specific") {
            displayConditions.push({
                label: "意向院校",
                value: selectedSchoolList.length > 0 ? selectedSchoolList.map((i) => i.name).join("，") : "不限",
            });
        }

        // 统一添加选科组合
        displayConditions.push({ label: "选科组合", value: selectedCombinationNameList.join("，") });

        const conditionsToShow = isExpanded ? displayConditions : displayConditions.slice(0, 3);

        return (
            <div className='xkCoach-wishList-analyze-overview'>
                <div className='page-container select-subject-result-container'>
                    <div className='section-overview'>
                        <div className='title'>查询条件</div>
                        <div className='content'>
                            <div className='filter'>
                                {conditionsToShow.map((condition, index) => (
                                    <div
                                        className='region'
                                        key={index}
                                        onClick={
                                            isXkCoachLimit && this.disabledOperation ? null : this.handleEditProvince
                                        }>
                                        {condition.label}：{condition.value}
                                    </div>
                                ))}
                                {displayConditions.length > 3 && (
                                    <div className='toggle-button' onClick={this.toggleExpand}>
                                        {isExpanded ? "收起" : "展开"}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className='section-overview'>
                        <div className='title'>可选比例分析</div>
                        <div className='content'>
                            <p className='p2'>
                                根据你选择的院校范围和意向专业，我们为你统计了每个选科组合的可选比例数据，具体如下：
                            </p>
                            {Object.keys(analysisData).length > 0 ? (
                                <div
                                    className={`table-total-contrast ${
                                        analysisData.totalEntryCount > 0 ? "" : "border-bottom"
                                    }`}>
                                    {this.dealTotalTable(analysisData).map((i, index) => {
                                        return (
                                            <div className='tr' key={index}>
                                                <div className={`td ${i.total || i.total == 0 ? "td-total" : ""}`}>
                                                    {i.title}
                                                    {(i.total || i.total == 0) && (
                                                        <div className='tips'>共{i.total}条</div>
                                                    )}
                                                </div>
                                                {i.content.map((c, index2) => {
                                                    let length = i.content.length;
                                                    return (
                                                        <div
                                                            className='td'
                                                            key={index2}
                                                            style={{
                                                                width:
                                                                    length == 3 ? "20%" : length == 2 ? "30%" : "60%",
                                                            }}>
                                                            {c}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        );
                                    })}
                                    {analysisData.totalEntryCount > 0 && (
                                        <div
                                            className='to-detail'
                                            onClick={() => {
                                                let main = document.getElementsByClassName("page-container")[0];
                                                setSessionData("overview-position", main.scrollTop);
                                                this.props.history.push({
                                                    pathname: frontPath + "analyzeDetail",
                                                    state: {
                                                        analysisData,
                                                        selectedCombinationNameList,
                                                        provinceId,
                                                        year,
                                                        selectedScoreType,
                                                        selectedCombinationList,
                                                    },
                                                });
                                            }}>
                                            对比详细选科要求
                                            <img src={toFinishedBlackIcon} alt='' />
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div className='table-total-contrast border-bottom'>
                                    {this.dealTotalTable(analysisData).map((i, index) => {
                                        return (
                                            <div className='tr' key={index}>
                                                <div className={`td ${i.total || i.total == 0 ? "td-total" : ""}`}>
                                                    {i.title}
                                                    {(i.total || i.total == 0) && (
                                                        <div className='tips'>共{i.total}条</div>
                                                    )}
                                                </div>
                                                {i.content.map((c, index2) => {
                                                    let length = i.content.length;
                                                    return (
                                                        <div
                                                            className='td'
                                                            key={index2}
                                                            style={{
                                                                width:
                                                                    length == 3 ? "20%" : length == 2 ? "30%" : "60%",
                                                            }}>
                                                            {c}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className='action-buttons'>
                    <button className='main-button' disabled={overlayVisible} onClick={this.handleGetReport}>
                        获取完整报告
                    </button>
                    <button className='action-button' onClick={this.handleBack}>
                        重新查询
                    </button>
                </div>

                {overlayVisible && (
                    <div className='overlay'>
                        <div className='overlay-content'>
                            <button className='close-button' onClick={this.handleCloseOverlay}>
                                ×
                            </button>
                            <img
                                src={getReportPic}
                                alt='Get Report'
                                onMouseDown={this.handleMouseDown}
                                onMouseUp={this.handleMouseUp}
                                onTouchStart={this.handleMouseDown}
                                onTouchEnd={this.handleMouseUp}
                                onMouseLeave={this.handleMouseUp}
                                className='overlay-image'
                            />
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default SelectSubjectResult;



// WEBPACK FOOTER //
// ./src/pages/SelectSubject/SelectSubjectResult.js